module.exports = __webpack_public_path__ + "img/dat_xe_hd.2a93d6a9.png";